module.exports = __webpack_public_path__ + "static/media/row-of-blocks.196363b6.png";